module.exports = __webpack_public_path__ + "img/comm-03-milestone-modal-bg-01.44489f33.jpg";